// Modül 3 - Aday Nasıl Davranmalı? - TAM İNTERAKTİF İÇERİKLER

const cabinCrewContentsM3Interactive = {
  // ÜNİTE 1: GRUP DİNAMİĞİ
  'CM-M3-U1-L1': {
    lesson_id: 'CM-M3-U1-L1',
    title: 'Aktif Dinleme',
    type: 'interactive',
    duration: 5,
    xp: 20,
    content: {
      title: '👂 Aktif Dinleme Sanatı',
      intro: 'Dinlemek = Anlamak. Sadece duymak değil!',
      facts: [
        { icon: '👀', title: 'Göz Teması', text: 'Konuşana bakın' },
        { icon: '🤔', title: 'Anlama', text: 'Söyleneni içselleştirin' },
        { icon: '📝', title: 'Not', text: 'Zihinsel not alın' },
        { icon: '✅', title: 'Onay', text: 'Baş sallama, "anladım" gibi' }
      ],
      challenge: {
        type: 'multipleChoice',
        question: 'Aktif dinleme nasıl gösterilir?',
        options: [
          { text: 'Telefona bakmak', isCorrect: false, feedback: '❌ İlgisizlik göstergesi!' },
          { text: 'Göz teması ve baş sallama', isCorrect: true, feedback: '✅ Jüri bunu görüyor!' },
          { text: 'Sözü kesmek', isCorrect: false, feedback: '❌ Saygısızlık!' }
        ]
      }
    }
  },

  'CM-M3-U1-L2': {
    lesson_id: 'CM-M3-U1-L2',
    title: 'Katkı Sağlama',
    type: 'interactive',
    duration: 5,
    xp: 20,
    content: {
      title: '💡 Grup Tartışmasına Katkı',
      intro: 'Ne çok sessiz, ne çok başat!',
      categories: [
        { icon: '✅', title: 'Doğru', examples: 'Fikirleri destekle', desc: '"Bu fikre katılıyorum çünkü..."' },
        { icon: '✅', title: 'Doğru', examples: 'Yeni açı ekle', desc: '"Bir de şunu düşünebiliriz..."' },
        { icon: '❌', title: 'Yanlış', examples: 'Söz kesmek', desc: 'Kaba ve saygısız' },
        { icon: '❌', title: 'Yanlış', examples: 'Tamamen sessiz', desc: 'Katkısız görünürsünüz' }
      ],
      challenge: {
        type: 'multipleChoice',
        question: 'İdeal grup katkısı nasıl?',
        options: [
          { text: 'Her konuda ilk sözü almak', isCorrect: false, feedback: '❌ Baskın görünürsünüz!' },
          { text: 'Dengeli katkı, başkalarını destekleme', isCorrect: true, feedback: '✅ Takım oyuncusu!' },
          { text: 'Hiç konuşmamak', isCorrect: false, feedback: '❌ Değerlendirilmeye yardımcı olmaz!' }
        ]
      }
    }
  },

  'CM-M3-U1-L3': {
    lesson_id: 'CM-M3-U1-L3',
    title: 'Senaryo: Sessiz Grup',
    type: 'scenario',
    duration: 5,
    xp: 30,
    scenario: {
      question: '🤫 SENARYO: Sessiz Grup',
      context: 'Grup mülakatında herkes sessiz kalıyor. Kimse konuşmuyor. Ne yaparsınız?',
      options: [
        { id: 'A', text: 'Nazikçe söz alır, tartışmayı başlatır ve diğerlerini davet ederim', isCorrect: true },
        { id: 'B', text: 'Ben de sessiz kalırım', isCorrect: false },
        { id: 'C', text: 'Tüm tartışmayı tek başıma yürütürüm', isCorrect: false },
        { id: 'D', text: 'Jüriye şikayet ederim', isCorrect: false }
      ],
      feedback: {
        correct: '🎯 Harika! İnisiyatif ve takımı dahil etme!',
        wrong: '❌ Sessizlikte bile fırsat var. İnisiyatif alın ama tek başına değil!'
      },
      explanation: '"Kim başlamak ister? Ben bir fikir sunayım, siz ne düşünüyorsunuz?" gibi.'
    }
  },

  // ÜNİTE 2: DENGE KURMA
  'CM-M3-U2-L1': {
    lesson_id: 'CM-M3-U2-L1',
    title: 'Ne Baskın Ne Pasif',
    type: 'interactive',
    duration: 5,
    xp: 20,
    content: {
      title: '⚖️ Denge: Altın Orta',
      intro: 'Baskın = Elenme. Pasif = Görünmezlik.',
      facts: [
        { icon: '🚫', title: 'BASKİN', text: 'Söz keser, herkesi yönetir' },
        { icon: '🚫', title: 'PASİF', text: 'Hiç konuşmaz, görünmez' },
        { icon: '✅', title: 'İDEAL', text: 'Dengeli katkı, işbirliği' },
        { icon: '⭐', title: 'HEDEF', text: 'Takım oyuncusu ol' }
      ],
      challenge: {
        type: 'multipleChoice',
        question: 'Jüri kimi elemez?',
        options: [
          { text: 'Hep konuşan, söz kesen', isCorrect: false, feedback: '❌ Baskın = Eleme!' },
          { text: 'Dengeli, işbirlikçi, takım oyuncusu', isCorrect: true, feedback: '✅ İdeal aday!' },
          { text: 'Hiç konuşmayan', isCorrect: false, feedback: '❌ Değerlendiremezler!' }
        ]
      }
    }
  },

  'CM-M3-U2-L2': {
    lesson_id: 'CM-M3-U2-L2',
    title: 'Orta Yol Bulma',
    type: 'interactive',
    duration: 5,
    xp: 20,
    content: {
      title: '🎯 Orta Yol Stratejisi',
      intro: 'Profesyonel denge nasıl kurulur?',
      steps: [
        { level: 1, title: '👂 Dinle', desc: 'Önce başkalarını dinle' },
        { level: 2, title: '💡 Katkı', desc: 'Uygun yerde fikir sun' },
        { level: 3, title: '🤝 Destek', desc: 'İyi fikirleri destekle' },
        { level: 4, title: '🔄 Davet', desc: 'Sessizleri dahil et' }
      ],
      challenge: {
        type: 'multipleChoice',
        question: 'Sessiz bir arkadaşı nasıl dahil edersiniz?',
        options: [
          { text: '"Sen neden konuşmuyorsun?" demek', isCorrect: false, feedback: '❌ Bu utandırıcı!' },
          { text: '"X, sen ne düşünüyorsun?" diye nazikçe sormak', isCorrect: true, feedback: '✅ Saygılı ve dahil edici!' },
          { text: 'Görmezden gelmek', isCorrect: false, feedback: '❌ Takım ruhu değil!' }
        ]
      }
    }
  },

  'CM-M3-U2-L3': {
    lesson_id: 'CM-M3-U2-L3',
    title: 'Ünite Sınavı',
    type: 'quiz',
    duration: 5,
    xp: 40,
    quiz: {
      questions: [
        { q: 'Grup mülakatında ideal davranış?', options: ['Baskın olmak', 'Sessiz kalmak', 'Dengeli katkı', 'Rekabet'], correct: 2 },
        { q: 'Aktif dinleme neyi içerir?', options: ['Telefona bakmak', 'Göz teması', 'Söz kesmek', 'Uyumak'], correct: 1 },
        { q: 'Sessiz grupta ne yapmalı?', options: ['Beklemek', 'İnisiyatif almak', 'Şikayet etmek', 'Gitmek'], correct: 1 },
        { q: 'Baskın aday ne yapar?', options: ['Dinler', 'Söz keser', 'Destek olur', 'Soru sorar'], correct: 1 }
      ]
    }
  },

  // ÜNİTE 3: İLETİŞİM STRATEJİLERİ
  'CM-M3-U3-L1': {
    lesson_id: 'CM-M3-U3-L1',
    title: 'Sözsüz İletişim',
    type: 'interactive',
    duration: 5,
    xp: 25,
    content: {
      title: '👁️ Vücut Dili',
      intro: 'Sözleriniz %7, vücut diliniz %55 etkili!',
      facts: [
        { icon: '😄', title: 'Gülümseme', text: 'Doğal ve sıcak' },
        { icon: '🧍', title: 'Duruş', text: 'Dik, güvenli' },
        { icon: '🤝', title: 'El Sıkma', text: 'Sıkı ama aşırı değil' },
        { icon: '👀', title: 'Göz Teması', text: 'Dikme değil, doğal' }
      ],
      challenge: {
        type: 'multipleChoice',
        question: 'Kol kavşturma ne ifade eder?',
        options: [
          { text: 'Açıklık', isCorrect: false, feedback: '❌ Kapalı vücut dili!' },
          { text: 'Savunmacılık/Kapalılık', isCorrect: true, feedback: '✅ Kollar açık tutun!' },
          { text: 'Rahatlama', isCorrect: false, feedback: '❌ Aslında gerginlik gösterir!' }
        ]
      }
    }
  },

  'CM-M3-U3-L2': {
    lesson_id: 'CM-M3-U3-L2',
    title: 'Etkili Konuşma Teknikleri',
    type: 'interactive',
    duration: 5,
    xp: 25,
    content: {
      title: '🗣️ Etkili Konuşma',
      intro: 'Net, öz ve etkileyici',
      categories: [
        { icon: '🎯', title: 'Net', examples: 'Dolaysiz ifade', desc: 'Uzatmayın' },
        { icon: '✂️', title: 'Öz', examples: 'Kısa ve öz', desc: 'Gereksiz detaydan kaçının' },
        { icon: '💪', title: 'Güvenli', examples: 'Emin ton', desc: 'Tereddütlü değil' },
        { icon: '😊', title: 'Pozitif', examples: 'Çözüm odaklı', desc: 'Şikayet değil, öneri' }
      ],
      challenge: {
        type: 'multipleChoice',
        question: 'Cevap verirken ideal süre?',
        options: [
          { text: '5 saniye', isCorrect: false, feedback: '❌ Çok kısa!' },
          { text: '30-60 saniye', isCorrect: true, feedback: '✅ Öz ama yeterli!' },
          { text: '5 dakika', isCorrect: false, feedback: '❌ Çok uzun, başkalarına fırsat bırakın!' }
        ]
      }
    }
  },

  'CM-M3-U3-L3': {
    lesson_id: 'CM-M3-U3-L3',
    title: 'Senaryo: Zor Soru Anı',
    type: 'scenario',
    duration: 8,
    xp: 40,
    scenario: {
      question: '❓ SENARYO: Bilmediğiniz Soru',
      context: 'Jüri size havacılık teknik bir soru sordu. Cevabı bilmiyorsunuz. Ne yaparsınız?',
      options: [
        { id: 'A', text: 'Dürüstçe bilmediğimi söyler, öğrenme isteğimi belirtirim', isCorrect: true },
        { id: 'B', text: 'Uydururum', isCorrect: false },
        { id: 'C', text: 'Sessiz kalırım', isCorrect: false },
        { id: 'D', text: 'Başka konuya geçerim', isCorrect: false }
      ],
      feedback: {
        correct: '🎯 Mükemmel! Dürüstlük + öğrenme isteği = profesyonellik!',
        wrong: '❌ Uydurma ve kaçınma en kötü tepkiler. Dürüst olun.'
      },
      explanation: '"Bu konuda detaylı bilgim yok, ama eğitimde öğrenmek isterim" demek dürüstlük gösterir.'
    }
  },

  'CM-M3-U3-L4': {
    lesson_id: 'CM-M3-U3-L4',
    title: '🎮 İletişim Eşleştirme',
    type: 'matching',
    duration: 4,
    xp: 35,
    matching: {
      instruction: 'İletişim tekniklerini eşleştir',
      pairs: [
        { id: 1, left: 'Göz Teması', right: 'İlgi ve güven gösterir' },
        { id: 2, left: 'Kol Kavuşturma', right: 'Kapalı vücut dili' },
        { id: 3, left: 'Gülümseme', right: 'Sıcaklık ve yakınlık' },
        { id: 4, left: 'Dik Duruş', right: 'Güven ve profesyonellik' },
        { id: 5, left: 'Baş Sallama', right: 'Aktif dinleme göstergesi' }
      ]
    }
  },

  // ÜNİTE 4: GRUP İÇİ ROLLER
  'CM-M3-U4-L1': {
    lesson_id: 'CM-M3-U4-L1',
    title: 'Grup Mülakatında Roller',
    type: 'interactive',
    duration: 5,
    xp: 25,
    content: {
      title: '🎭 Grup Mülakatı Rolleri',
      intro: 'Her grupta doğal roller oluşur',
      facts: [
        { icon: '👑', title: 'Lider', text: 'Yönlendirir, organize eder' },
        { icon: '🔗', title: 'Koordinatör', text: 'Fikirleri birleştirir' },
        { icon: '💡', title: 'Fikir Üreticisi', text: 'Yaratıcı öneriler' },
        { icon: '🤝', title: 'Destekçi', text: 'İyi fikirleri destekler' }
      ],
      challenge: {
        type: 'multipleChoice',
        question: 'En güvenli rol hangisi?',
        options: [
          { text: 'Baskın lider', isCorrect: false, feedback: '❌ Baskın liderlik riskli!' },
          { text: 'Dengeli katılımcı', isCorrect: true, feedback: '✅ Tüm roller dengeli olursa ideal!' },
          { text: 'Sessiz gözlemci', isCorrect: false, feedback: '❌ Görünmez olursunuz!' }
        ]
      }
    }
  },

  'CM-M3-U4-L2': {
    lesson_id: 'CM-M3-U4-L2',
    title: 'Rekabet vs İşbirliği',
    type: 'interactive',
    duration: 5,
    xp: 25,
    content: {
      title: '🤼 Rekabet mi İşbirliği mi?',
      intro: 'Havayolları işbirliği arar!',
      categories: [
        { icon: '❌', title: 'Rekabet', examples: 'Başkalarını kötüleme', desc: 'YANLIŞ!' },
        { icon: '❌', title: 'Eleştiri', examples: 'Fikirleri yıkma', desc: 'YANLIŞ!' },
        { icon: '✅', title: 'İşbirliği', examples: 'Fikirleri geliştirme', desc: 'DOĞRU!' },
        { icon: '✅', title: 'Destek', examples: 'İyi fikirlere +1', desc: 'DOĞRU!' }
      ],
      challenge: {
        type: 'multipleChoice',
        question: 'Birinin fikri sizinkinden iyiyse?',
        options: [
          { text: 'Eleştiririm, kendi fikrimi savunurum', isCorrect: false, feedback: '❌ Ego sorunu!' },
          { text: 'Desteklerim, üzerine eklerim', isCorrect: true, feedback: '✅ Takım oyuncusu!' },
          { text: 'Görmezden gelirim', isCorrect: false, feedback: '❌ Katılım yok!' }
        ]
      }
    }
  },

  'CM-M3-U4-L3': {
    lesson_id: 'CM-M3-U4-L3',
    title: 'Senaryo: Baskın Aday',
    type: 'scenario',
    duration: 8,
    xp: 40,
    scenario: {
      question: '🚨 SENARYO: Baskın Aday',
      context: 'Gruptaki bir aday sürekli sözünüzü kesiyor ve sizin fikirlerinizi küçümsüyor. Ne yaparsınız?',
      options: [
        { id: 'A', text: 'Sakin kalır, profesyonelliğimi korur, fikrimi nazikçe söylerim', isCorrect: true },
        { id: 'B', text: 'Ben de onun sözünü keserim', isCorrect: false },
        { id: 'C', text: 'Kavga ederim', isCorrect: false },
        { id: 'D', text: 'Susarım', isCorrect: false }
      ],
      feedback: {
        correct: '🎯 Mükemmel! Stres altında sakinlik = kabin memuru özelliği!',
        wrong: '❌ Jüri sizin nasıl tepki verdiğinizi izliyor. Sakin ve profesyonel kalın.'
      },
      explanation: 'Jüri zaten baskın adayı fark eder. Sizin sakinliğiniz artı puan.'
    }
  },

  'CM-M3-U4-L4': {
    lesson_id: 'CM-M3-U4-L4',
    title: '⚡ Rol Yarışı',
    type: 'timerace',
    duration: 4,
    xp: 45,
    timerace: {
      timePerQuestion: 8,
      questions: [
        { q: 'İdeal grup rolü?', options: ['Baskın lider', 'Dengeli katılımcı', 'Sessiz', 'Eleştirmen'], correct: 1 },
        { q: 'Rekabet mi işbirliği mi?', options: ['Rekabet', 'İşbirliği', 'Fark etmez', 'İkisi de'], correct: 1 },
        { q: 'Baskın aday varsa?', options: ['Kavga et', 'Sakin kal', 'Sus', 'Kaç'], correct: 1 },
        { q: 'Koordinatör ne yapar?', options: ['Eleştirir', 'Birleştirir', 'Böler', 'Susar'], correct: 1 },
        { q: 'İyi fikre tepki?', options: ['Eleştir', 'Destekle', 'Görmezden gel', 'Küçümse'], correct: 1 }
      ]
    }
  },

  // ÜNİTE 5: PRATİK SENARYOLAR
  'CM-M3-U5-L1': {
    lesson_id: 'CM-M3-U5-L1',
    title: 'Sık Yapılan Hatalar',
    type: 'interactive',
    duration: 5,
    xp: 25,
    content: {
      title: '⚠️ Sık Yapılan Hatalar',
      intro: 'Bu hataları yapmayın!',
      facts: [
        { icon: '🚫', title: 'Söz Kesmek', text: 'En büyük hata!' },
        { icon: '🚫', title: 'Eleştirmek', text: 'Başkalarını kötülemek' },
        { icon: '🚫', title: 'Baskın Olmak', text: 'Tüm konuşmayı yönetmek' },
        { icon: '🚫', title: 'Pasif Kalmak', text: 'Hiç katkı yapmamak' }
      ],
      challenge: {
        type: 'multipleChoice',
        question: 'En ölümcül hata?',
        options: [
          { text: 'Az konuşmak', isCorrect: false, feedback: '❌ Kötü ama ölümcül değil' },
          { text: 'Başkalarını eleştirmek/küçümsemek', isCorrect: true, feedback: '✅ Bu kesin eleme sebebi!' },
          { text: 'Gergin olmak', isCorrect: false, feedback: '❌ Normal, herkes gergin' }
        ]
      }
    }
  },

  'CM-M3-U5-L2': {
    lesson_id: 'CM-M3-U5-L2',
    title: 'Senaryo: Fikir Çatışması',
    type: 'scenario',
    duration: 8,
    xp: 40,
    scenario: {
      question: '⚡ SENARYO: Fikir Çatışması',
      context: 'Grup tartışmasında sizin fikriniz ile başka birinin fikri tam zıt. Grup bölündü. Ne yaparsınız?',
      options: [
        { id: 'A', text: 'Ortak noktaları bulur, uzlaşma öneririm', isCorrect: true },
        { id: 'B', text: 'Kendi fikrimi savunmaya devam ederim', isCorrect: false },
        { id: 'C', text: 'Pes ederim', isCorrect: false },
        { id: 'D', text: 'Jüriye karar vermesini isterim', isCorrect: false }
      ],
      feedback: {
        correct: '🎯 Mükemmel! Uzlaşma ve problem çözme yeteneği!',
        wrong: '❌ Çatışma değil, çözüm arıyorsunuz. Ortak nokta bulun.'
      },
      explanation: '"Her iki fikrin de güçlü yanları var. Şunu birleştirebilir miyiz?" gibi.'
    }
  },

  'CM-M3-U5-L3': {
    lesson_id: 'CM-M3-U5-L3',
    title: '🎮 Hata Bul: Doğru/Yanlış',
    type: 'truefalse',
    duration: 4,
    xp: 35,
    truefalse: {
      statements: [
        { statement: 'Grup mülakatında en çok konuşan kazanır.', isTrue: false, explanation: '❌ Dengeli katkı kazanır!' },
        { statement: 'Başkalarının fikirlerini desteklemek iyidir.', isTrue: true, explanation: '✅ Takım oyuncusu!' },
        { statement: 'Bilmediğim soruya uydururum.', isTrue: false, explanation: '❌ Dürüstlük şart!' },
        { statement: 'Göz teması önemlidir.', isTrue: true, explanation: '✅ Güven ve ilgi gösterir!' },
        { statement: 'Rekabet işbirliğinden önemlidir.', isTrue: false, explanation: '❌ Havayolları işbirliği arar!' }
      ]
    }
  },

  // ÜNİTE 6: FİNAL
  'CM-M3-U6-L1': {
    lesson_id: 'CM-M3-U6-L1',
    title: '🎓 Modül 3 Final Sınavı',
    type: 'exam',
    duration: 10,
    xp: 80,
    exam: {
      questions: [
        { q: 'Aktif dinleme neyi içerir?', options: ['Telefona bakma', 'Göz teması', 'Söz kesme', 'Uyuma'], correct: 1 },
        { q: 'İdeal grup davranışı?', options: ['Baskın', 'Pasif', 'Dengeli', 'Rekabetçi'], correct: 2 },
        { q: 'Baskın aday varsa?', options: ['Kavga et', 'Sakin kal', 'Sus', 'Şikayet et'], correct: 1 },
        { q: 'Bilmediğiniz soruya?', options: ['Uydur', 'Dürüst ol', 'Kaçın', 'Sessiz kal'], correct: 1 },
        { q: 'Kol kavşturma ne ifade eder?', options: ['Açıklık', 'Kapalılık', 'Rahatlama', 'Özgüven'], correct: 1 },
        { q: 'Fikir çatışmasında?', options: ['Kavga', 'Uzlaşma', 'Pes', 'Sus'], correct: 1 },
        { q: 'En ölümcül hata?', options: ['Gerginlik', 'Eleştiri', 'Az konuşma', 'Hızlı konuşma'], correct: 1 },
        { q: 'Sessiz arkadaşa?', options: ['Görmezden gel', 'Dahil et', 'Eleştir', 'Şikayet et'], correct: 1 },
        { q: 'Grup mülakatında hedef?', options: ['Kazanmak', 'Takım oyuncusu', 'Lider', 'Eleştirmen'], correct: 1 },
        { q: 'Cevap süresi ideal?', options: ['5 sn', '30-60 sn', '5 dk', '10 dk'], correct: 1 }
      ]
    }
  }
};

export default cabinCrewContentsM3Interactive;
